const CapConstant = {
   EDIT_APPSETTINGS: 1001,
   MANAGE_CCA_GROUP: 1002,
   MANAGE_LOCATION: 1003,
   SEND_MESSAGE: 1004,
   MANAGE_USER: 1005,
   TAKE_ATTENDANCE: 1006,
   ARCHIVE_GROUP: 1007,
   PUBLISH_GROUP: 1008,
   CREATE_GROUP: 1009,
   GROUP_ADMIN: 1010,
   MANAGE_WAITLIST: 1011,
   SUBSCRIBE_GROUP: 1012,
   MESSAGES: 1013,
   MANAGE_PARTICIPANTLIST: 1014,
   MANAGE_EVENTLIST: 1015,
   ADD_GROUP_ADMIN: 1016,
   VIEW_CCA_LOG: 1017,
   MODIFY_ATTENDANCE: 1018,
   COPY_GROUP: 1019,
   VIEW_CONSENT_ACTIVITY: 1020,
   CCA_PROPOSAL_FORM: 1021,
   MANAGE_PROPOSAL: 1022,
   VIEW_CCA_STATISTIC: 1023,
   STUDENT_PROFILE: 1024,
   VIEW_ATTENDANCE_HISTORY: 1025,
   UPDATE_DUE_DATE: 1026,
   PARTICIPANT_LIST: 1027,
};

export default CapConstant;
